import React, { Component } from "react";
import {
  Grid,
  withStyles,
  FormControl,
  FormLabel,
  FormGroup,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import { moduleToGroup } from "../../../utils/setting";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { styles } from "./style";
import _ from "lodash";
class Module extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupModule: {},
      package: {},
      initPackages: {},
    };
  }

  componentDidMount() {
    this.props.onRef(this);
  }
  groupModule = (packages) => {
    let json = moduleToGroup(packages);
    this.setState({
      groupModule: json,
    });
  };
  handleChange = (name, action) => (event) => {
    let { handleStatusButton } = this.props;
    let keyPackage = Object.keys(this.state.package);
    let packages = this.state.package;
    keyPackage.map((key, index) => {
      switch (key) {
        case name: {
          packages[name][action] = event.target.checked ? 1 : 0;
          break;
        }
      }
    });
    if (handleStatusButton) handleStatusButton(false);
    this.setState({ package: packages }, function () {
      this.groupModule(packages);
    });
  };
  getModule = () => {
    return this.state.package;
  };
  getInitModule = () => {
    // return JSON.parse(this.state.initPackages)
    return this.state.initPackages;
  };
  handleShowModule = (packages) => {
    let _this = this;
    this.setState(
      { package: _.cloneDeep(packages), initPackages: _.cloneDeep(packages) },
      function () {
        // this.setState({package: packages, initPackages: JSON.stringify(packages)}, function(){
        _this.groupModule(packages);
      }
    );
  };
  render() {
    const { classes, t } = this.props;
    const { groupModule = {} } = this.state;
    let keysGroupModule = Object.keys(groupModule);
    return (
      <Grid container className={classes.root}>
        {keysGroupModule.map((keyGroup, i) => {
          let values = Object.keys(groupModule[keyGroup]) || [];
          return values.map((a, j) => {
            let valuesKeysGroup = Object.values(groupModule[keyGroup]);
            let keysDetail = Object.keys(valuesKeysGroup[j]) || [];
            let find_package = keysDetail.find((e) => e === "package");
            if (find_package) find_package = valuesKeysGroup[j][find_package];

            return (
              <Grid item xs={4} sm={3} md={2} key={j}>
                <FormControl
                  component="fieldset"
                  className={classes.formControl}
                >
                  {j === 0 ? (
                    <FormLabel component="legend" className={classes.title}>
                      {t("module_" + keyGroup)}
                    </FormLabel>
                  ) : (
                    <FormLabel component="legend" className={classes.title}>
                      {""}
                    </FormLabel>
                  )}
                  <FormLabel component="legend" className={classes.formLabel}>
                    {t("module_" + a)}{" "}
                    {find_package ? (
                      <img
                        class="package-icon"
                        src={`/images/${find_package}-medal.svg`}
                      />
                    ) : (
                      ""
                    )}
                  </FormLabel>
                  {keysDetail.map((b, k) => {
                    return b !== "limit" && b !== "package" ? (
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                Object.values(valuesKeysGroup[j])[k] === 1
                                  ? true
                                  : false
                              }
                              onChange={this.handleChange(a, b)}
                              value={b}
                            />
                          }
                          className={classes.label}
                          label={t("module_action_" + b)}
                        />
                      </FormGroup>
                    ) : (
                      ""
                    );
                  })}
                </FormControl>
              </Grid>
            );
          });
        })}
      </Grid>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: 0 })(Module)));
